/**
 * @generated SignedSource<<141dd5f3dbe1bbb0b52b7b26291ab403>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePromotionalCodeMutation$variables = {
  id: string;
};
export type DeletePromotionalCodeMutation$data = {
  readonly DeletePromotionalCode: boolean;
};
export type DeletePromotionalCodeMutation = {
  response: DeletePromotionalCodeMutation$data;
  variables: DeletePromotionalCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "DeletePromotionalCode",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePromotionalCodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeletePromotionalCodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3420b3cd4cbc47701342ee459d106bc8",
    "id": null,
    "metadata": {},
    "name": "DeletePromotionalCodeMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePromotionalCodeMutation(\n  $id: ID!\n) {\n  DeletePromotionalCode(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "b10a6c091b512b4a256464b2e9f5087d";

export default node;
